import {immerable} from "immer";
import { Note } from "./Note";
export interface KeyParams{
    tonic:number
    keyIndex:number
    rowIndex:number
    columnIndex:number
    x:number 
    y:number
    radius:number
}
export class Key{
    [immerable] = true 
    params:KeyParams
    noteIndexes:number[]
    selectedState:number = Note.SelectedState_Default  
    defined:boolean = true
    visible:boolean = true
    classNames:string[] = []
    open:boolean = true
    predefinedLabel:string|null = null
    secondaryLabel:string|null = null
    constructor(params:KeyParams){
        this.params = params
        this.noteIndexes = Array<number>(7)
    }
    static isSelected = (key:Key) =>  { return (key.selectedState === Note.SelectedState_Selected) }
    static isHilited = (key:Key) =>  { return (key.selectedState === Note.SelectedState_Hilited) }
    static isDefault = (key:Key) =>  { return (key.selectedState === Note.SelectedState_Default) }  
}